import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions } from '@material-ui/core';

import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import useStyles from '../footer.styles';

// #35936: a FUZZY active-policy match (member + primary property / cars + product, a different or
// unknown quote) warns instead of hard-blocking Send-to-underwriting — a member can legitimately
// hold several policies. Mirrors the checkout "purchase anyway?" dialog (#35249): the agent
// confirms and we re-send with acknowledgeExistingActivePolicy. The exact-offer-id case never
// reaches here (the footer hard-disables the button for it).
const ActivePolicyAckModal = ({ open, policyIds, onClose, onConfirm }) => {
  const classes = useStyles();
  const ids = policyIds?.filter(Boolean) ?? [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogContent className={classes.modalContainer}>
        <Label type="greenBig">This member already has an active policy</Label>
        <Label type="modalBody">
          {ids.length
            ? `An active policy (${ids.join(', ')}) already exists for this member at this property. A member can ` +
              'hold more than one policy, so this may be intentional — send to underwriting anyway, or cancel to review.'
            : 'An active policy already exists for this member at this property. A member can hold more than one ' +
              'policy, so this may be intentional — send to underwriting anyway, or cancel to review.'}
        </Label>
      </DialogContent>
      <DialogActions className={classes.modalActions}>
        <Button variant="contained" color="secondary" className={classes.btn} onClick={onClose}>
          <Label className={classes.btnLabel}>No, cancel</Label>
        </Button>
        <Button variant="contained" color="primary" className={classes.btn} onClick={onConfirm}>
          <Label className={classes.btnLabel}>Send anyway</Label>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ActivePolicyAckModal.propTypes = {
  open: PropTypes.bool.isRequired,
  policyIds: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ActivePolicyAckModal;
